import visitsCircle from '../view/systemManage/visits-circle/visits-circle'
//联防圈子
import circle from '../view/systemManage/visits-circle/circle/circle.vue'//圈子
import visits from '../view/systemManage/visits-circle/visits/visits.vue'//联防

const test = {
    path: '/visits-circle',
    component: visitsCircle,
    redirect: '/visits-circle/visits',
    children: [
		//联防圈子
		{
		    path: '/visits-circle/circle',
		    name: 'circle',
		    component: circle,
			meta:{
		        title: '家乡圈'
		    }
		},
		{
		    path: '/visits-circle/visits',
		    name: 'visits',
		    component: visits,
		    meta: {
		        title: '十户联防'
		    }
		},

    ]
}

export default test
